<template>
  <div
    v-if="show"
    class="absolute top-0 w-full h-full border-4 border-vice-teal-500 rounded-xl"
  ></div>
  <div class="absolute right-3 w-8 h-8" :class="speakingIndicatorClass">
    <div class="relative w-full h-full flex justify-around px-1">
      <div
        :class="{ 'scale-0': !show }"
        class="
          bg-vice-teal-500
          absolute
          w-full
          h-full
          rounded-full
          z-10
          transition-transform
          duration-100
          transform
        "
      ></div>
      <template v-if="show">
        <div v-for="i in [4, 6, 4]" :key="i" class="w-1 h-full flex items-center z-20">
          <div class="absolute bg-white w-1 h-1 rounded-full"></div>
          <div
            class="bg-white w-full rounded-lg transition-transform duration-75"
            :class="`h-${i}`"
            :style="indicatorScalingStyle"
          ></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';

export default {
  name: 'SpeakingIndicator',
  props: {
    audioLevel: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const show = ref(false);
    const sessionStore = useSessionStore();

    const speakingIndicatorClass = ref(null);

    const indicatorScalingStyle = computed(() => {
      let normalizedAudioLevel = props.audioLevel * 5;

      if (props.audioLevel < 0.08) {
        normalizedAudioLevel = 0;
      } else if (normalizedAudioLevel > 1) {
        normalizedAudioLevel = 0.9;
      }

      return {
        transform: `scaleY(${normalizedAudioLevel.toFixed(3)})`,
      };
    });

    watch(indicatorScalingStyle, (newVal, oldVal) => {
      if (newVal.transform == oldVal.transform) return;
      show.value = true;
      hideIndicator();
    });

    const hideIndicator = _.debounce(() => {
      show.value = false;
    }, 2000);

    onMounted(() => {
      if (!sessionStore.userIsObserver && sessionStore.currentPhaseData.title === 'Consultation') {
        speakingIndicatorClass.value = 'top-1/2 mt-negative-16px';
      } else {
        speakingIndicatorClass.value = 'top-2.5';
      }
    });

    return {
      show,
      indicatorScalingStyle,
      speakingIndicatorClass,
    };
  },
};
</script>
<style scoped>
.mt-negative-16px {
  margin-top: -16px;
}
</style>
